import {StyledInputRadio} from '@components/ui/input-radio/style.ts'
import {forwardRef, InputHTMLAttributes} from 'react'

export const InputRadio = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>>(
    (props, ref) => <StyledInputRadio type="radio" ref={ref} {...props} />
)
